import { Megaphone, AlertTriangle } from 'lucide-react'

const dateFmt = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
const formatDate = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : dateFmt.format(d)
}

/** Liste d'annonces (notes de version). Utilisée par la modale et le panneau topbar. */
export default function AnnouncementList({ items, compact = false }) {
  if (!items?.length) {
    return <p className="py-6 text-center text-sm text-ink/30">Aucune nouveauté pour le moment.</p>
  }
  return (
    <ul className="space-y-3">
      {items.map((a) => {
        const important = a.level === 'important'
        const Icon = important ? AlertTriangle : Megaphone
        return (
          <li
            key={a.id}
            className={`rounded-xl border p-3 ${
              a.unseen ? 'border-brand/30 bg-brand/[0.04]' : 'border-ink/10 bg-ink/[0.02]'
            }`}
          >
            <div className="flex items-center gap-2">
              <Icon className={`h-4 w-4 shrink-0 ${important ? 'text-orange-400' : 'text-aqua'}`} />
              <h4 className="flex-1 truncate text-sm font-semibold text-ink">{a.title}</h4>
              {a.unseen && (
                <span className="shrink-0 rounded-full bg-brand/15 px-1.5 py-0.5 text-[10px] font-semibold text-brand-text">
                  nouveau
                </span>
              )}
            </div>
            <p className={`mt-1.5 whitespace-pre-wrap text-sm text-ink/70 ${compact ? 'line-clamp-3' : ''}`}>
              {a.body}
            </p>
            <p className="mt-2 text-[11px] text-ink/35">
              {formatDate(a.publishedAt)}{a.author ? ` · ${a.author}` : ''}
            </p>
          </li>
        )
      })}
    </ul>
  )
}
